/* eslint-disable */
import { useState, useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
export default function Page(props){
  let navigate = useNavigate()
  let location = useLocation()
  let [bgUrl, setBgUrl] = useState('')
  useEffect(() => {
    if(location.pathname.includes('intro')){
      setBgUrl('/img/sub_banner_01.png')
    }else if(location.pathname.includes('business')){
      setBgUrl('/img/sub_banner_02.png')
    }else if(location.pathname.includes('company')){
      setBgUrl('/img/sub_banner_03.png')
    }else if(location.pathname.includes('human')){
      setBgUrl('/img/sub_banner_04.png')
    }else{
      setBgUrl('')
    }
  }, [location.pathname])
  useEffect(() => {
    document.querySelector('.pageTitle').classList.remove('on')
    document.querySelector('.pageBox').classList.remove('on')
    setTimeout(() => {
      document.querySelector('.pageTitle').classList.add('on')
      document.querySelector('.pageBox').classList.add('on')
    }, 100)
  }, [location.pathname])
  return(
    <>
      {
        props.menu ?
        <div className="pageWrap" style={{backgroundImage:`url(${bgUrl})`}}>
          <div className="pageTitle">{props.menu?.name}</div>
          <div className="pageBox">
            <div className="pageStep01">
              <button className="homeBtn" onClick={() => {navigate('/')}}>
                <img src="/img/home.png" alt="home"/>
              </button>
              {props.menu?.name}
            </div>
            <button
              className="pageStep02"
              onClick={(e) => {
                e.stopPropagation()
                props.setIsPageDrop(!props.isPageDrop)
              }}
            >
              <img src="/img/arrow.png" alt="arrow" className={props.isPageDrop ? 'on' : ''}/>
              {props.menu.sub.filter(a => a.url.includes(props.pathname))[0]?.name}
            </button>
          </div>
          {
            props.isPageDrop &&
            <div className="pageDropMenu">
              {
                props.menu.sub.map((a, i) => (
                  <button
                    key={i}
                    className="pageBtn"
                    onClick={() => {
                      navigate(a.url)
                      props.setIsPageDrop(false)
                    }}
                  >
                    {a?.name}
                  </button>
                ))
              }
            </div>
          }
        </div> : ''
      }
    </>
  )
}